import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { spacing } from '@retailer-platform/shared-components'
import { ReportsNormalizedReportsGridList } from './components/grid-list/ReportsNormalizedReportsGridList'
import { ReportsNormalizedReportsListFilters } from './components/filters/ReportsNormalizedReportsListFilters'
import { useReportsNormalizedReportsList } from './utils/useReportsNormalizedReportsList.hooks'
import { type ReportTypeConfig } from './utils/ReportsNormalizedReportsList.utils'

interface ReportsNormalizedReportsListProps {
  partnerId: string
  retailerId: string
  reportTypesConfig: ReportTypeConfig
  filterUnavailableReportTypes?: boolean
}

const StyledGridListWrapper = styled.div({
  padding: `0 ${spacing.X24}`,
  overflow: 'hidden',
  width: '100%',
  flex: 1,
})

export const InstacartManagedReportsList: FunctionComponent<
  React.PropsWithChildren<ReportsNormalizedReportsListProps>
> = ({ partnerId, retailerId, reportTypesConfig, filterUnavailableReportTypes }) => {
  const {
    apiResult,
    loading,
    refetch,
    canLoadMore,
    loadMore,
    dateRangePreset,
    setDateRangePreset,
    dateRange,
    setDateRange,
    reportType,
    setReportType,
    error,
    warehouseOptions,
    retailerIds,
    setRetailerIds,
    storeGroupId,
    setStoreGroupId,
    isHeavyQuery,
  } = useReportsNormalizedReportsList({
    partnerId,
    retailerId,
    reportTypesConfig,
  })
  // @ts-expect-error TS2339 — strictNullChecks. TODO: fix strict null check
  const hasPgpReport = apiResult?.some(report => report.fileType === 'pgp') ?? false

  return (
    <React.Fragment>
      <ReportsNormalizedReportsListFilters
        reportCount={apiResult?.length ?? 0}
        partnerId={partnerId}
        retailerId={retailerId}
        dateRangePreset={dateRangePreset}
        setDateRangePreset={setDateRangePreset}
        // @ts-expect-error TS2322 — strictNullChecks. TODO: fix strict null check
        dateRange={dateRange}
        setDateRange={setDateRange}
        // @ts-expect-error TS2322 — strictNullChecks. TODO: fix strict null check
        reportType={reportType}
        setReportType={setReportType}
        warehouseOptions={warehouseOptions}
        retailerIds={retailerIds}
        setRetailerIds={setRetailerIds}
        storeGroupId={storeGroupId}
        setStoreGroupId={setStoreGroupId}
        reportTypesConfig={reportTypesConfig}
        filterUnavailableReportTypes={filterUnavailableReportTypes}
        hasPgpReport={hasPgpReport}
      />
      <StyledGridListWrapper>
        <ReportsNormalizedReportsGridList
          // @ts-expect-error TS2322 — strictNullChecks. TODO: fix strict null check
          reports={apiResult}
          loading={loading}
          loadMore={loadMore}
          canLoadMore={canLoadMore}
          refetch={refetch}
          error={error}
          isHeavyQuery={isHeavyQuery}
          reportType={reportType}
        />
      </StyledGridListWrapper>
    </React.Fragment>
  )
}
